import { useNavigate } from 'react-router-dom'
import CabinaTopbar from '@/components/cabina/CabinaTopbar'

/**
 * Onboarding post-registro (asignación plan Free inicial DEC-026).
 * Identidad visual "Cabina de inteligencia" (Fase 3). Bienvenida sobria con
 * CTA a la app. La conexión al backend (crear `mp_user_subscriptions` con
 * plan Free) se mantiene como tarea posterior.
 */
const STEPS: { icon: JSX.Element; t: string; d: string }[] = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="7" /><path d="M21 21l-4-4" />
      </svg>
    ),
    t: 'Elige zona y sector',
    d: 'Define dónde y qué negocios quieres mapear.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 17l6-6 4 4 8-8" /><path d="M21 7v5h-5" />
      </svg>
    ),
    t: 'Extrae y prioriza',
    d: 'Recibe los leads ya ordenados por oportunidad.',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 11.5a8.4 8.4 0 01-12.3 7.4L3 21l2.1-5.7A8.4 8.4 0 1121 11.5z" />
      </svg>
    ),
    t: 'Contacta',
    d: 'Llega a quien más te conviene, primero.',
  },
]

export default function Onboarding() {
  const navigate = useNavigate()
  return (
    <div className="cabina-root">
      <CabinaTopbar />
      <div className="auth-screen" style={{ minHeight: 'calc(100vh - 60px)' }}>
        <div className="onb-card">
          <div className="onb-ic">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 20l-5 2V6l5-2 6 2 5-2v16l-5 2-6-2z" /><path d="M9 4v16M15 6v16" />
            </svg>
          </div>
          <h1>Tu cuenta está lista</h1>
          <p>
            Bienvenida/o a MapeoData. Empiezas con el plan Gratuito (15 leads al mes);
            puedes pasar a Starter o Pro cuando quieras desde la sección Plan.
          </p>

          <div className="onb-steps">
            {STEPS.map((s) => (
              <div className="onb-step" key={s.t}>
                <div className="os-ic">{s.icon}</div>
                <div className="os-t">{s.t}</div>
                <div className="os-d">{s.d}</div>
              </div>
            ))}
          </div>

          <button onClick={() => navigate('/app')} className="btn btn-accent">
            Ir a mi cabina
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}
